import { Box, FormControl, MenuItem, Select, Typography, useMediaQuery, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import StatBox from "../../components/StatBox";
import PieChart from "../../components/PieChart";
import BarChartData from "../../components/BarChart";
import LineChartData from "../../components/LineChart";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getAggregate, getdealerBarChart, geteleBarChart, getfabBarChart, getlinechart, getMarketBarChartData, getMarLiaBarChartData, getpiechart, getStackchartData, gettechBarChart } from "../../redux/slice/dashboard.slice";
import MarketLiasoning from "../../components/MarketLiasoning";
import Markrt from "../../components/Markrt";
import Dealer from "../../components/Dealer";
import InstallerFab from "../../components/InstallerFab";
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const currentYear = dayjs();

const getFinancialYearRange = (date) => {
  const year = dayjs(date).year();
  const month = dayjs(date).month(); // 0 = Jan

  let startYear = month >= 3 ? year : year - 1; // April logic

  return {
    startDate: dayjs(`${startYear}-04-01`),
    endDate: dayjs(`${startYear + 1}-03-31`)
  };
};

const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery('(max-width:500px)');
  const isNarrowScreen = useMediaQuery('(max-width:920px)');
  const dispatch = useDispatch()
  const { aggregate, piechart, marketBarChartData, stackchart, MarLiaData, linechart, dealerBar, fabBar, eleBar, techBar, status } = useSelector(state => state.dashboard)

  const aggregateStatus = aggregate.status
  const marketStatus1 = aggregate.marketStaus
  const piechartStatus = piechart.status
  const lineStatus = linechart.status
  const stackStatus = stackchart.status
  const marketStatus = marketBarChartData.status
  const marketLiasoningStatus = MarLiaData.status
  const DealerStatus = dealerBar.status
  const fabStatus = fabBar.status
  const eleStatus = eleBar.status
  const techStatus = techBar.status

  const [selectedfilter, setSelectedfilter] = useState('month');
  const [stackselectedfilter, setstackSelectedfilter] = useState('month');
  const [installerFilter, setInstallerFilter] = useState('month');
  const [selectedCommonfilter, setSelectedCommonfilter] = useState('total');
  const [selectedDate, setSelectedDate] = useState(currentYear);

  let payload = { selectedCommonfilter, selectedDate };



console.log("payload", payload);


  useEffect(() => {
    dispatch(getlinechart({ selectedfilter: selectedfilter }));
    dispatch(getStackchartData({ selectedfilter: stackselectedfilter }));
    dispatch(getfabBarChart({ selectedfilter: installerFilter }));
    dispatch(geteleBarChart({ selectedfilter: installerFilter }));
    dispatch(gettechBarChart({ selectedfilter: installerFilter }));

    dispatch(getAggregate(payload));
    dispatch(getMarketBarChartData(payload));
    dispatch(getpiechart(payload));
    dispatch(getdealerBarChart(payload));
  }, [dispatch, selectedCommonfilter, selectedDate, selectedfilter, stackselectedfilter, installerFilter])


  console.log("marketBarChartDatamarketBarChartData", marketBarChartData);


  return (
    <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden', }}>
      <Header
        title="DASHBOARD"
        subtitle="Manage Your Dashboard Here"
      />

      {(aggregateStatus || DealerStatus || marketStatus || marketLiasoningStatus || piechartStatus || lineStatus || stackStatus) && (
        <Box display="flex" justifyContent="flex-end" alignItems="center" mb={2}>
          <FormControl size="small" sx={{ display: { xs: 'block', sm: 'inline-flex' }, ml: { xs: 0, md: 2 }, marginRight: '10px' }}>
            <Select
              labelId="month-select-label"
              id="month-select"
              value={selectedCommonfilter}
              onChange={(e) => setSelectedCommonfilter(e.target.value)}
              sx={{
                width: '150px',
                height: '40px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#566585',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#566585',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#566585',
                  borderWidth: '2px',
                },
              }}
            >
              <MenuItem value="total">Total</MenuItem>
              <MenuItem value="year">Year</MenuItem>
              <MenuItem value="month">Month</MenuItem>
              <MenuItem value="financialYear">Financial Year</MenuItem> {/* ✅ NEW */}
            </Select>
          </FormControl>
          {selectedCommonfilter !== 'total' &&
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                maxDate={currentYear}
                openTo="year"
                views={
                  selectedCommonfilter === 'year' || selectedCommonfilter === 'financialYear'
                    ? ['year']
                    : ['year', 'month']
                }
                yearsOrder="desc"
                value={selectedDate}
                onChange={(newValue) => {
                  setSelectedDate(newValue);
                }}
                sx={{
                  marginLeft: '10px',
                  '& .MuiInputBase-root': {
                    width: '150px',
                    height: '40px',
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#566585',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#566585',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#566585',
                    borderWidth: '2px',
                  },
                }}
              />
            </LocalizationProvider>
          }
        </Box>
      )}

      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="140px"
        gap="20px"
      >
        {/*............... first four box.............. */}
        {(aggregateStatus || marketStatus) && (
          <>
            <Box
              sx={{
                gridColumn: { xs: "span 12", sm: "span 6", md: "span 3", xxl: "span 1" },
                backgroundColor: colors.primary[400],
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginX: "10px"
              }}
            >
              <StatBox
                title={`${(aggregate?.data?.totalSystemSizeKw)?.toFixed(2) || 0} KW`}
                subtitle="Total KW"
              />
            </Box>
            <Box
              sx={{
                gridColumn: { xs: "span 12", sm: "span 6", md: "span 3", xxl: "span 1" },
                backgroundColor: colors.primary[400],
                display: "flex",
                alignItems: "center",
                marginX: "10px",
                justifyContent: "center",
              }}
            >
              <StatBox
                title={aggregate?.data?.totalCount?.toLocaleString()}
                subtitle="Total Customers"
              />
            </Box>
          </>
        )
        }
        {
          aggregateStatus && (
            <>
              <Box
                sx={{
                  gridColumn: { xs: "span 12", sm: "span 6", md: "span 3", xxl: "span 1" },
                  backgroundColor: colors.primary[400],
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginX: "10px"
                }}
              >
                <StatBox
                  title={aggregate.data.totalAmount?.toLocaleString()}
                  subtitle="Total Sales"
                />
              </Box>
              <Box
                sx={{
                  gridColumn: { xs: "span 12", sm: "span 6", md: "span 3", xxl: "span 1" },
                  backgroundColor: colors.primary[400],
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginX: "10px"
                }}
              >
                <StatBox
                  title={aggregate.data.totalAccountAmount?.toLocaleString()}
                  subtitle="Total Recievble Payment"
                />
              </Box>
            </>
          )

        }

        {/*............... Pie Chart.............. */}
        {piechartStatus && (
          <Box
            sx={{
              gridColumn: { xs: "span 12", sm: "span 12", md: "span 12", lg: "span 6" },
              gridRow: "span 3",
              backgroundColor: colors.primary[400],
              marginX: "10px"
            }}
          >
            <Box
              mt="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography
                  variant="h5"
                  fontWeight="600"
                  color={colors.grey[100]}
                >
                  Pie Chart
                </Typography>
              </Box>
            </Box>
            <Box height="320px" style={{ marginTop: "40px" }}>
              <PieChart piechartData={piechart} />
            </Box>
          </Box>
        )}

        {/*............... Line Chart.............. */}
        {lineStatus && (
          <Box
            sx={{
              gridColumn: { xs: "span 12", sm: "span 12", md: "span 12", lg: "span 6" },
              gridRow: "span 3",
              backgroundColor: colors.primary[400],
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              marginX: "10px"

            }}
          >
            <Box
              my="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography
                  variant="h5"
                  fontWeight="600"
                  color={colors.grey[100]}
                >
                  Line Chart
                </Typography>
              </Box>
              <Box>
                <FormControl size="small" sx={{ display: { xs: 'block', sm: 'inline-flex' }, ml: { xs: 0, md: 2 } }}>
                  <Select
                    labelId="month-select-label"
                    id="month-select"
                    value={selectedfilter}
                    onChange={(e) => setSelectedfilter(e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                        borderWidth: '2px',
                      },
                      width: '110px',
                    }}
                  >
                    <MenuItem value="month">Month</MenuItem>
                    <MenuItem value="day">Day</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>
            <Box height="250px" mt="-20px">
              <div style={{ minWidth: '800px', display: 'inline-block' }} >
                <LineChartData isDashboard={true} linechart={linechart} selectedfilter={selectedfilter} />
              </div>
            </Box>
          </Box>
        )}

        {/*............... Stack Chart.............. */}
        {stackStatus && (
          <Box
            sx={{
              gridColumn: { xs: "span 12", sm: "span 12", md: "span 12", lg: "span 12" },
              gridRow: "span 3",
              backgroundColor: colors.primary[400],
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              marginX: "10px"

            }}
          >
            <Box
              my="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography
                  variant="h5"
                  fontWeight="600"
                  color={colors.grey[100]}
                >
                  Stack Chart
                </Typography>
              </Box>
              <Box>
                <FormControl size="small" sx={{ display: { xs: 'block', sm: 'inline-flex' }, ml: { xs: 0, md: 2 } }}>
                  <Select
                    labelId="month-select-label"
                    id="month-select"
                    value={stackselectedfilter}
                    onChange={(e) => setstackSelectedfilter(e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                        borderWidth: '2px',
                      },
                      width: '110px',
                    }}
                  >
                    <MenuItem value="month">Month</MenuItem>
                    <MenuItem value="day">Day</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>
            <Box height="250px" m="-20px 0 0 0">
              <div style={{ minWidth: isNarrowScreen ? '800px' : '100%', display: 'inline-block' }}>
                <BarChartData isDashboard={true} stackchart={stackchart} selectedfilter={stackselectedfilter} />
              </div>
            </Box>
          </Box>
        )}

        {/* ............Market.......... */}
        {marketStatus && (
          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={colors.primary[400]}
            sx={{
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              marginX: "10px"
            }}
          >
            <Box
              mt="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography
                  variant="h5"
                  fontWeight="600"
                  color={colors.grey[100]}
                >
                  Market Chart
                </Typography>
              </Box>
            </Box>
            <Box height="220px" m="-20px 0 0 0">
              <Markrt marketBarChartData={marketBarChartData} />
            </Box>
          </Box>
        )}

        {/* ............Market & Liasoning.......... */}
        {marketLiasoningStatus && (
          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={colors.primary[400]}
            sx={{
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              marginX: "10px"
            }}
          >
            <Box
              mt="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography
                  variant="h5"
                  fontWeight="600"
                  color={colors.grey[100]}
                >
                  Market & Liasoning Chart
                </Typography>
              </Box>
            </Box>
            <Box height="220px" m="-20px 0 0 0">
              <MarketLiasoning liabarchart={MarLiaData} />
            </Box>
          </Box>
        )}

        {/* ............Dealer Chart............ */}
        {DealerStatus && !aggregateStatus && (
          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={colors.primary[400]}
            sx={{
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              marginX: "10px"
            }}
          >
            <Box
              mt="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography
                  variant="h5"
                  fontWeight="600"
                  color={colors.grey[100]}
                >
                  Dealer Chart
                </Typography>
              </Box>
            </Box>
            <Box height="220px" m="-20px 0 0 0">
              <Dealer isDashboard={true} dealerBar={dealerBar} selectedCommonfilter={selectedCommonfilter} />
            </Box>
          </Box>
        )}
      </Box>

      {
        (fabStatus || eleStatus || techStatus) && (
          <Box display="flex" justifyContent="flex-end" alignItems="center" my={2}>
            <FormControl size="small" sx={{ display: { xs: 'block', sm: 'inline-flex' }, marginRight: '10px' }}>
              <Select
                labelId="month-select-label"
                id="month-select"
                value={installerFilter}
                onChange={(e) => setInstallerFilter(e.target.value)}
                sx={{
                  width: '150px',
                  height: '40px',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#566585',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#566585',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#566585',
                    borderWidth: '2px',
                  },
                }}
              >
                <MenuItem value="month">Month</MenuItem>
                <MenuItem value="day">Day</MenuItem>
              </Select>
            </FormControl>
          </Box>
        )
      }

      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="140px"
        gap="20px"
      >
        {/* ..............Installer & Fab..............  */}
        {fabStatus && (
          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={colors.primary[400]}
            sx={{
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              marginX: "10px"
            }}
          >
            <Box
              mt="25px"
              pt="10px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography
                  variant="h5"
                  fontWeight="600"
                  color={colors.grey[100]}
                >
                  Fabricator Chart
                </Typography>
              </Box>
            </Box>
            <Box height="220px" m="-20px 0 0 0">
              <InstallerFab isDashboard={true} data={fabBar} />
            </Box>
          </Box>
        )}

        {/* ..............Installer & Ele..............  */}
        {eleStatus && (
          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={colors.primary[400]}
            sx={{
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              marginX: "10px"
            }}
          >
            <Box
              mt="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography
                  variant="h5"
                  fontWeight="600"
                  color={colors.grey[100]}
                >
                  Electrician Chart
                </Typography>
              </Box>
            </Box>
            <Box height="220px" m="-20px 0 0 0">
              <InstallerFab isDashboard={true} data={eleBar} />
            </Box>
          </Box>
        )}

        {/* ..............Installer & tech..............  */}
        {techStatus && (
          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={colors.primary[400]}
            sx={{
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              marginX: "10px"
            }}
          >
            <Box
              mt="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography
                  variant="h5"
                  fontWeight="600"
                  color={colors.grey[100]}
                >
                  Technician Chart
                </Typography>
              </Box>
            </Box>
            <Box height="220px" m="-20px 0 0 0">
              <InstallerFab isDashboard={true} data={techBar} />
            </Box>
          </Box>
        )}
      </Box>
    </Box >
  );
};

export default Dashboard;
